
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/TransferSceneCards",
      function () {
        return require("private-next-pages/products/TransferSceneCards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/TransferSceneCards"])
      });
    }
  